import React from 'react';
import styled from 'styled-components';

import IconButton from '@material-ui/core/IconButton';
import VolumeHighIcon from 'mdi-material-ui/VolumeHigh';

import { withMediaProps } from 'react-media-player';

const AudioButton = styled(IconButton)`
  opacity: 0.5;
`;

class SimplePlayButton extends React.Component {
  shouldComponentUpdate({ media }) {
    return this.props.media.isPlaying !== media.isPlaying;
  }

  _handlePlayPause = () => {
    this.props.media.playPause();
  };

  render() {
    return (
      <AudioButton onClick={this._handlePlayPause}>
        <VolumeHighIcon />
      </AudioButton>
    );
  }
}

export default withMediaProps(SimplePlayButton);
